<div class="drawer-content">
    <ng-container *ngIf="isLoading">
      <div class="loading-container">
        <nz-spin nzTip="Loading..."></nz-spin>
      </div>
    </ng-container>
  
    <ng-container *ngIf="error">
      <nz-alert nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>
    </ng-container>
  
    <ng-container *ngIf="!isLoading && !error && postDetails">
      <div class="post-details-section">
       <br />       
        <nz-descriptions nzBordered [nzColumn]="1" nzSize="small">
          <nz-descriptions-item nzTitle="Posted by">{{ postDetails.politician?.name }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Posted on">{{ formatDatetime(postDetails.date) }}</nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Post Content">
            <div class="post-text">{{ postDetails.caption }}</div>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Post URL">
            <a [href]="postDetails.url" target="_blank">
              {{ postDetails.url }} &nbsp;
              <fa-icon [icon]="faExternalLink"></fa-icon>
            </a>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Engagement">
            <nz-tag [nzColor]="'blue'"  nz-tooltip nzTooltipTitle="Likes">
              <i nz-icon nzType="like" nzTheme="outline"></i> {{ postDetails.likesCount }}
            </nz-tag>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Type" *ngIf="postDetails?.type">{{ postDetails.type?.type }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Topic" *ngIf="postDetails?.topic">{{ postDetails.topic?.name }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Attacked Politician" *ngIf="postDetails.attackedPolitician">{{ postDetails.attackedPolitician }}</nz-descriptions-item>
        </nz-descriptions>
      </div>
    </ng-container>

    <ng-container *ngIf="postDetails?.id != null">
      <app-instagram-comments [postId]="postDetails?.id"></app-instagram-comments>
    </ng-container>
  
    <div class="drawer-footer">
      <button nz-button nzType="primary" (click)="close()">Close</button>
    </div>
  </div>